import { HttpResponse } from '@angular/common/http';

export const InterceptorHelper = class InterceptorHelperClass
{
  static IsJsonRpc(httpResponse: HttpResponse<any>): boolean {
    const body = httpResponse.body;

    return body.jsonrpc && body.jsonrpc === '2.0';
  }

  static NoAuthorizeJsonRpc(httpResponse: HttpResponse<any>): boolean {
    const body = httpResponse.body;

    return body.error && (body.error.code === -32600 || body.error.code === -32003); // -32003 - User didn't find
  }
};
